import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Button,
  Box,
  Fade,
  Paper,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  InputAdornment
} from '@material-ui/core'
import { FormLoader } from '../../../Loader/FormLoader'
import { formStyles } from '../FormStyles'
import { useStyles } from '../Styles'
import { useFormik } from 'formik'
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FormTextField from '../../../../FormFields/FormTextField'
import DateFnsUtils from '@date-io/date-fns'
import arSA from 'date-fns/locale/ar-SA'
import enUS from 'date-fns/locale/en-US'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { LanguageConsumer } from '../../../../context/LanguageContext'
import FormDateTimeField from '../../../../FormFields/FormDateTimeField'
import { calculateDecimal } from '../../../../utils/helpers'
import SaveInvoiceBtn from '../../SaveInvoiceBtn'
import countryCodes from '../../../../configurations/country-codes'
import FormSelectField from '../../../../FormFields/FormSelectField'

const InvoiceCreateStep5 = ({ invoiceData, onSubmit, handleBackStep, handleSaveInvoiceEntity, savedTemplateData }) => {
  const classes = useStyles()
  const formClasses = formStyles()
  const invoiceStep5Form = useFormik({
    initialValues: (!!Object.keys(invoiceData?.step5 || {}).length) ? invoiceData.step5 : {
      approach: '',
      packaging: '',
      dateValidity: '',
      exportPort: '',
      countryOfOrigin: '',
      grossWeight: null,
      netWeight: null,
      deliveryTerms: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    // validationSchema: CreateInvoiceStep4FormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, 'step5')
    })
  })
  const [validityDate, setValidityDate] = React.useState(invoiceData?.step5?.dateValidity ? new Date(invoiceData?.step5?.dateValidity) : null)

  const handleValidityDateChange = (date) => {
    setValidityDate(date)
    invoiceStep5Form.setFieldValue('dateValidity', date)
  }

  const DecimalChange = (event, fieldName) => {
    const re = /^[0-9]*\.?[0-9]*$/
    if (event.target.value === '' || re.test(event.target.value)) {
      invoiceStep5Form.setFieldValue(fieldName, event.target.value)
    }
  }
  const DecimalBlur = (event, fieldName) => {
    let value = calculateDecimal(event.target.value)
    invoiceStep5Form.setFieldValue(fieldName, value)
  }

  return (
    <LanguageConsumer>
      {({ locale }) => (
        <Fade in={true}>
          <Paper elevation={4} className={classes.invoiceStepWrapper + ' step2'}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
              <form onSubmit={invoiceStep5Form.handleSubmit} noValidate autoComplete="off"
                    className={formClasses.formWrapper}>
                <div className={classes.IssuerReceiverWrapper + ' row'}>
                  <Accordion defaultExpanded={true} elevation={0}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon/>}
                      className={classes.IssuerReceiverHeaderWrapper}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <div className={classes.IssuerReceiverHeader}>
                        <Typography className={classes.ItemHeading}><TrendingUpIcon color={'primary'}/><FormattedMessage
                          id='InvoiceSteps.step4.Delivery.title'/> <span
                          className={classes.Optional}>(<FormattedMessage id='Optional'/>)</span></Typography>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className={classes.IssuerReceiverDetailsWrapper}>

                      <FormTextField name={'approach'} lines={3}
                                     labelKey={'Fields.label.approach'} classes={formClasses}
                                     formActions={invoiceStep5Form}/>

                      <FormTextField name={'packaging'} lines={3}
                                     labelKey={'Fields.label.packaging'} classes={formClasses}
                                     formActions={invoiceStep5Form}/>

                      <FormDateTimeField name={'dateValidity'} labelKey={'Fields.label.dateValidity'}
                                         classes={formClasses} formActions={invoiceStep5Form}
                                         value={validityDate} handleChange={handleValidityDateChange}/>

                      <FormTextField name={'exportPort'}
                                     labelKey={'Fields.label.exportPort'} classes={formClasses}
                                     formActions={invoiceStep5Form}/>

                      {/*<FormTextField name={'countryOfOrigin'}*/}
                      {/*               labelKey={'Fields.label.countryOfOrigin'} classes={formClasses}*/}
                      {/*               formActions={invoiceStep5Form}/>*/}
                      <FormSelectField name={'countryOfOrigin'} labelKey={'Fields.label.countryOfOrigin'}
                                       classes={formClasses} displayEmpty formActions={invoiceStep5Form}
                                       list={countryCodes} locale={locale}/>

                      <FormTextField name={'grossWeight'} labelKey={'Fields.label.grossWeight'} classes={formClasses}
                                     formActions={invoiceStep5Form}
                                     onChange={(event) => DecimalChange(event, 'grossWeight')}
                                     onBlurFn={(event) => DecimalBlur(event, 'grossWeight')}
                                     InputAttributes={{
                                       endAdornment: <InputAdornment position="end"><FormattedMessage
                                         id='kg'/></InputAdornment>
                                     }}/>

                      <FormTextField name={'netWeight'} labelKey={'Fields.label.netWeight'} classes={formClasses}
                                     formActions={invoiceStep5Form}
                                     onChange={(event) => DecimalChange(event, 'netWeight')}
                                     onBlurFn={(event) => DecimalBlur(event, 'netWeight')}
                                     InputAttributes={{
                                       endAdornment: <InputAdornment position="end"><FormattedMessage
                                         id='kg'/></InputAdornment>
                                     }}/>

                      <FormTextField name={'deliveryTerms'} lines={3}
                                     labelKey={'Fields.label.deliveryTerms'} classes={formClasses}
                                     formActions={invoiceStep5Form}/>

                    </AccordionDetails>
                  </Accordion>
                </div>
                <LanguageConsumer>
                  {({ locale }) => (
                    <Box px={3} className={formClasses.FormSubmitRow + ' between'}>
                      <Button variant={'outlined'} size={'large'} color={'secondary'}
                              className={formClasses.InvoiceStepGoBack} onClick={handleBackStep}>
                        {locale === 'ar' ? <ArrowForwardIosOutlinedIcon/> : <ArrowBackIosOutlinedIcon/>}
                        <FormattedMessage id='requestStep.button.previous'/>
                      </Button>
                      <div>
                        <SaveInvoiceBtn disabled={!!invoiceStep5Form.isSubmitting || !invoiceStep5Form.isValid}
                                        savedTemplateData={savedTemplateData}
                                        handleSaveInvoiceEntity={(e, entityType, tempData, formikActions, closeDialog) => handleSaveInvoiceEntity(e, entityType,
                                          invoiceStep5Form.values, 'step5', tempData, formikActions, closeDialog)}/>
                        <Button type={'submit'} variant={'contained'} size={'large'} color={'secondary'}
                                onClick={invoiceStep5Form.handleSubmit}
                                disabled={invoiceStep5Form.isSubmitting || !invoiceStep5Form.isValid}
                        >
                          <FormattedMessage id='invoiceSteps.button.submit'/>
                          {locale === 'ar' ? <ArrowBackIosOutlinedIcon/> : <ArrowForwardIosOutlinedIcon/>}
                        </Button>
                      </div>
                    </Box>
                  )}
                </LanguageConsumer>
                {!!invoiceStep5Form.isSubmitting && <FormLoader loading={true}/>}
              </form>
            </MuiPickersUtilsProvider>
          </Paper>
        </Fade>
      )}
    </LanguageConsumer>
  )
}

export default InvoiceCreateStep5
